// extracted by mini-css-extract-plugin
export default {"bestPractice":"LevelCheck_bestPractice__9KHos","bestPracticeHeader":"LevelCheck_bestPracticeHeader__vBOtu"};